import { ArrowLeft, Space } from "lucide-react";

const KEYBOARD = [
  ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "BACKSPACE"],
  ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
  ["Z", "X", "C", "V", "B", "N", "M"],
  ["SPACE"],
];

const KEYBOARD_NUMBERS = [
  ["7", "8", "9"],
  ["4", "5", "6"],
  ["1", "2", "3"],
  ["0", ".", "BACKSPACE"],
];

export function Keyboard({
  mode = "uppercase",
  onChange,
  value,
  type = "letters",
}: {
  mode?: "uppercase" | "lowercase" | "capitalize";
  onChange: (value: string) => void;
  value: string;
  type?: "letters" | "numbers";
}) {
  const handleChange = (value: string) => {
    if (mode === "uppercase") {
      onChange(value.toUpperCase());
    } else if (mode === "lowercase") {
      onChange(value.toLowerCase());
    } else if (mode === "capitalize") {
      onChange(value.charAt(0).toUpperCase() + value.slice(1).toLowerCase());
    }
  };
  return (
    <div className="flex flex-col gap-4 w-full bg-gray-100 rounded-md p-4">
      {(type === "letters" ? KEYBOARD : KEYBOARD_NUMBERS).map((row) => (
        <div className="flex gap-4 w-full items-center justify-center">
          {row.map((key) => {
            if (key === "BACKSPACE") {
              return (
                <button
                  key={key}
                  className="flex-1 text-2xl font-bold border border-gray-200 rounded-md py-4 size-18 max-w-24 bg-red-100 items-center justify-center flex"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleChange(value.slice(0, -1));
                  }}
                >
                  <ArrowLeft className="size-7" />
                </button>
              );
            }
            if (key === "SPACE") {
              return (
                <button
                  key={key}
                  className="flex-1 text-2xl font-bold border border-gray-200 rounded-md py-4 size-18 bg-white items-center justify-center flex"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleChange(value + " ");
                  }}
                >
                  <Space className="size-7" />
                </button>
              );
            }
            return (
              <button
                key={key}
                className="flex-1 text-2xl font-bold border border-gray-200 rounded-md size-18 max-w-24 bg-white"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleChange(value + key);
                }}
                onKeyDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (e.key === key) {
                    handleChange(value + key);
                  }
                }}
              >
                {key}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
